import React from 'react'
import Link from 'gatsby-link'
import logo from '../img/logo.png'

class Navbar extends React.Component {

    render() {
        return (
            <nav className="navigation">
                <ul className="level">
                    <li className="level-item has-text-centered dropdown is-hoverable">
                        <div className="dropdown-trigger">
                            <a>projects</a>
                        </div>
                        <ul className="dropdown-menu">
                            <li>
                                <Link className="see-america-first" to="/see-america-first">
                                    see america first!
                                </Link>
                            </li>
                            <li>
                                <Link className="two-mile-high-city" to="/welcome-earthlings">
                                    welcome, earthlings</Link>
                            </li>
                            <li>
                                <Link className="two-mile-high-city" to="/two-mile-high-city">
                                    the two mile high city
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="level-item has-text-centered dropdown is-hoverable">
                        <div className="dropdown-trigger">
                            <a>portfolio</a>
                        </div>
                        <ul className="dropdown-menu">

                            <li>
                                <Link className="tourism" to="/tourism">
                                    tourism
                                </Link>
                            </li>
                            <li>
                                <Link className="travel" to="/travel">
                                    travel
                                </Link>
                            </li>
                            <li>
                                <Link className="commissioned" to="/commissioned">
                                    commissioned
                                </Link>
                            </li>
                            <li>
                                <Link className="tearsheets" to="/tearsheets">
                                    tearsheets
                                </Link>
                            </li>
                            <li>
                                <Link className="people" to="/people">
                                    people
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="level-item has-text-centered">
                        <Link className="home" to="/#si">
                            <figure className="image">
                                <img src={logo} style={{maxWidth: '130px'}}/>
                            </figure>
                        </Link>
                    </li>
                    <li className="level-item has-text-centered">
                        <Link className="about" to="/about">
                            about
                        </Link>
                    </li>
                    <li className="level-item has-text-centered dropdown is-hoverable">
                        <div className="dropdown-trigger">
                            <a>print shop</a>
                        </div>
                        <ul className="dropdown-menu">
                            <li>
                                <a className="coming-soon">
                                    coming soon
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>

        );
    }

}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Navbar.js